var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-403"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"bk_403"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("Error Forbidden~ 没有权限，请联系管理员 "),_c('button',{on:{"click":_vm.back}},[_vm._v("返回首页")])])]),_vm._v(" "),_c('div',{staticClass:"bk2"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcf6b48e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/error/e403/index.vue
// module id = null
// module chunks = 